<template>
    <div class="NavbarNotificaciones">
        <router-link :to="{ name: 'PerfilNotificaciones' }">
            <div class="position-relative" title="Notificaciones">
                <img src="@/assets/img/general_icono_notificaciones.webp" alt="icono-notificaciones" loading="lazy" />
                <span v-if="cantidad > 0"
                    class="position-absolute top-0 start-75 translate-middle badge rounded-pill bg-danger">
                    {{ cantidad }}
                </span>
            </div>
        </router-link>
    </div>
</template>

<script>
import { auth, db } from "@/firebase";
import { collection, query, where, onSnapshot } from "firebase/firestore";
export default {
    name: "NavbarNotificaciones",

    data() {
        return {
            cantidad: 0,
        }
    },

    async created() {
        let usuario = auth.currentUser;
        if (usuario) {
            let usuarioDB = await this.$store.state.usuario.funciones.obtener(usuario.uid);
            if (usuarioDB) {
                await this.obtenerNotificaciones();
            }
        }
    },

    methods: {
        async obtenerNotificaciones() {
            const q = query(
                collection(db, "notificaciones"),
                where("idUsuario.destinatario", "==", auth.currentUser.uid),
                where("esLeida", "==", false)
            );
            onSnapshot(q, (querySnapshot) => {
                this.cantidad = querySnapshot.docs.length;
            });
        }
    }
}
</script>

<style scoped>
button {
    background: transparent;
}

img {
    cursor: pointer;
    width: 24.54px;
    height: 26.94px;
    transition: transform 0.3s ease;
}

img:hover {
    transform: scale(1.05);
}

@media screen and (max-width: 768px) {
    img {
        width: 25px;
        filter: brightness(0) saturate(100%) invert(98%) sepia(1%) saturate(184%) hue-rotate(113deg) brightness(116%) contrast(100%);
    }
}
</style>